import React, { useState, useEffect } from "react";
import { txtA, txtE } from "../../../../Label/Lbl";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import n2words from "n2words";
import { useInvCa, useInvMain } from "../../../../St/Reviews/UseStyle";
import Paper from "@material-ui/core/Paper";

const BodySand = (props) => {
    const clasm = useInvMain();
    const clas = useInvCa();
    const [AE, setAE] = useState(null);
    const { sta, locinf } = props;
    const styleT = {
        textAlign: "center",
        fontSize: "1rem",
        color: "black",
        fontWeight: "bold",
    };
    const styleR = {
        textAlign: "right",
        fontSize: "0.8rem",
        color: "black",
        fontWeight: "bold",
        marginRight: "0.2rem"
    };
    const styleL = {
        textAlign: "left",
        fontSize: "0.8rem",
        fontWeight: "bold",
        marginLeft: "0.2rem"
    };
    const styleC = {
        textAlign: "center",
        fontSize: "0.8rem",
        fontWeight: "bold",
    };
    const styleC2 = {
        textAlign: "center",
        fontSize: "0.65rem",
        fontWeight: "bold",
        paddingTop: "0.2rem",
        paddingBottom: "0.2rem"
    };
    const styleTable = {
        textAlign: "center",
        fontSize: "0.6rem",
        fontWeight: "bold",
        paddingTop: "0.2rem",
    };
    const styleTable2 = {
        textAlign: "center",
        fontSize: "0.6rem",
        fontWeight: "bold",
        paddingBottom: "0.2rem"
    };

    const totalsContntE_ = () => {
        return (
            <Grid item container className={clas.BdytotSub}>
                <Grid item xs={8} className={clas.BdytotCntrVal}>
                   <div style={styleC}>{locinf.auto.empName}</div>
                </Grid>
                <Grid item xs={4} className={clas.BdytotCntr}>
                    <Grid item xs={12}>
                    <div style={styleC}>  {txtA.rpt[0].d[0]}</div>
                    </Grid>
                </Grid>

                <Grid item xs={8} className={clas.BdytotCntrVal}>
                   <div style={styleC}>{locinf?.endBalance??0}</div>
                </Grid>
                <Grid item xs={4} className={clas.BdytotCntr}>
                    <Grid item xs={12}>
                    <div style={styleC}>  {"رصيد الحساب"}</div>
                    </Grid>
                </Grid>

                <Grid item xs={8} className={clas.BdytotCntrVal}>
                <div style={styleC}> {"--------"}</div>
                </Grid>
                <Grid item xs={4} className={clas.BdytotCntr}>
                <div style={styleC}>{txtA.rpt[0].d[1]}</div>
                </Grid>

                {/* <Grid item xs={8} className={clas.BdytotCntrVal}>
                    {"--------"}
                </Grid>
                <Grid item xs={4} className={clas.BdytotCntr}>
                    <Grid item xs={12}>
                        {txtA.rpt[0].d[2]}
                    </Grid>
                </Grid>

                <Grid item xs={8} className={clas.BdytotCntrVal}>
                    {"--------"}
                </Grid>
                <Grid item xs={4} className={clas.BdytotCntr}>
                    <Grid item xs={12}>
                        {txtA.rpt[0].d[3]}
                    </Grid>
                </Grid>

                <Grid item xs={8} className={clas.BdytotCntrVal}>
                    {"--------"}
                </Grid>
                <Grid item xs={4} className={clas.BdytotCntr}>
                    <Grid item xs={12}>
                        {txtA.rpt[0].d[4]}
                    </Grid>
                </Grid>

                <Grid item xs={8} className={clas.BdytotCntrVal}>
                    {"--------"}
                </Grid>
                <Grid item xs={4} className={clas.BdytotCntr}>
                    <Grid item xs={12}>
                        {txtA.rpt[0].d[5]}
                    </Grid>
                </Grid> */}
            </Grid>
        );
    };

    return (
        <Grid item container className={clas.Bdyroot}>
            <Grid item container className={clas.BdyundrHeaderTF}>
                <Grid item xs={12} className={[clas.BdytitleHedDw, clas.BdytitleHed]}>
                    <Typography className={[clas.contnt, clasm.minclr]}>
                        <div style={styleT}>{locinf.title}</div>
                    </Typography>
                </Grid>
            </Grid>

            <Grid item container className={clas.Bdycntr}>
                {!sta.StngIA.showColDHd ? (
                    <Grid item xs={4} className={clas.BdyborBtR}>
                        <div style={styleL}> {txtA.rpt[1].t[0]}</div>
                    </Grid>
                ) : null}
                <Grid item xs={sta.StngIA.ncol} className={clasm.minborB}>
                    <Paper className={clasm.minclr}>
                        <div style={styleC}>{locinf.data.id}</div></Paper>
                </Grid>
                <Grid
                    item
                    xs={sta.StngIA.ncol}
                    className={clas.BdyborBtL}
                    style={{ fontSize: 9 }}
                >
                    <div style={styleR}>{txtA.rpt[0].t[0] + locinf.from}</div>
                </Grid>

                {!sta.StngIA.showColDHd ? (
                    <Grid item xs={4} className={clas.BdyborBtR}>
                        <div style={styleL}>{txtA.rpt[1].t[1]}</div>
                    </Grid>
                ) : null}
                <Grid item xs={sta.StngIA.ncol} className={clasm.minborB}>
                    <Paper className={clasm.minclr}> <div style={styleC}>{locinf.Date}</div></Paper>
                </Grid>
                <Grid item xs={sta.StngIA.ncol} className={clas.BdyborBtL}>

                    <div style={styleR}>{txtA.rpt[0].t[1]}</div>
                </Grid>

                {!sta.StngIA.showColDHd ? (
                    <Grid item xs={4} className={clas.BdyborBtR}>

                        <div style={styleL}>{txtA.rpt[1].t[2]}</div>
                    </Grid>
                ) : null}
                <Grid item xs={sta.StngIA.ncol} className={clasm.minborB}>
                    <Paper className={clasm.minclr}> <div style={styleC}>{locinf.data.ref_no}</div></Paper>
                </Grid>
                <Grid item xs={sta.StngIA.ncol} className={clas.BdyborBtL}>

                    <div style={styleR}> {txtA.rpt[0].t[2]}</div>
                </Grid>

                {!sta.StngIA.showColDHd ? (
                    <Grid item xs={4} className={clas.BdyborBtR}>
                        <div style={styleL}>{txtA.rpt[1].t[3]}</div>
                    </Grid>
                ) : null}
                <Grid item xs={sta.StngIA.ncol} className={clasm.minborB}>
                    <Paper className={clasm.minclr}><div style={styleC}> {locinf.auto.center}</div></Paper>
                </Grid>
                <Grid item xs={sta.StngIA.ncol} className={clas.BdyborBtL}>
                    <div style={styleR}>{txtA.rpt[0].t[3]}</div>
                </Grid>
            </Grid>

            <Grid item container className={clas.Bdycntr} style={{ marginTop: 10 }}>
                <Grid item xs={8}>
                    <Paper 
                    // className={clasm.minclr}
                    >
                        <div style={{ fontWeight: "bold",color:"#000", fontSize: "1rem", textAlign: "right" }}>
                            {locinf.auto.custName}</div></Paper>
                </Grid>
                <Grid item xs={4}>
                    <div style={{
                        fontWeight: "bold",color:"#000", marginRight: "0.2rem",
                        fontSize: "0.8rem", textAlign: "right"
                    }}>
                        {": " + locinf.custN}
                    </div>
                </Grid>

                <Grid item xs={8}>
                    <Paper className={clasm.minclr}>
                        <div style={styleR}>{"SR " + locinf.data.val}</div>
                    </Paper>
                </Grid>
                <Grid item xs={4}>
                    <div style={{
                        fontWeight: "bold",color:"#000", marginRight: "0.2rem",
                        fontSize: "0.9rem", textAlign: "right"
                    }}>
                        {": " + txtA.rpt[0].i[1]}
                    </div>
                </Grid>

                <Grid item xs={12} style={{color:"#000", fontWeight: "bold", fontSize: "0.9rem",}}>
                    <div style={styleC}>{txtA.rpt[0].i[2]}</div>
                </Grid>
            </Grid>

            <Grid item container className={clas.BdytablSnd}>
                <Grid item xs={7} className={clas.bG}>
                    <div style={styleTable}>{txtA.rpt[1].c[3]}</div>
                </Grid>
                <Grid item xs={2} className={clas.bG}>
                    <div style={styleTable}> {txtA.rpt[1].c[2]}</div>
                </Grid>
                {/* <Grid item xs={2} className={clas.bG}>
                    <div style={styleTable}> {txtA.rpt[1].c[1]}</div>
                </Grid> */}
                <Grid item xs={2} className={clas.bG}>
                    <div style={styleTable}> {txtA.rpt[1].c[0]}</div>
                </Grid>

                <Grid item xs={7} className={clas.bG}>
                    <div style={styleTable2}> {txtA.rpt[0].c[3]}</div>
                </Grid>
                <Grid item xs={2} className={clas.bG}>
                    <div style={styleTable2}> {txtA.rpt[0].c[2]}</div>
                </Grid>
                {/* <Grid item xs={2} className={clas.bG}>
                    <div style={styleTable2}> {txtA.rpt[0].c[1]}</div>
                </Grid> */}
                <Grid item xs={2} className={clas.bG}>
                    <div style={styleTable2}> {txtA.rpt[0].c[0]}</div>
                </Grid>
            </Grid>

            <Grid item container className={clas.Browskh}>
                <Grid item className={clas.bG} xs={2}>
                    <div style={styleC2}>{locinf.data.val}</div>
                </Grid>
                {/* <Grid item className={clas.bG} xs={2}>
                    <div style={styleC2}> {locinf.data.check_no}</div>
                </Grid> */}
                <Grid item className={clas.bG} xs={2}>
                    <div style={styleC2}> {locinf.Date}</div>
                </Grid>
                <Grid item className={clas.bG} xs={7}>
                    <div style={{ fontWeight: "bold",color:"#000", fontSize: "0.85rem", textAlign: "right" }}> {locinf.auto.custName}</div>
                </Grid>

            </Grid>

            <Grid item container className={clas.Bdycntr} style={{ marginTop: 10 }}>

                <Grid item xs={8}>
                    <Paper className={clasm.minclr}>
                        <div style={{ fontWeight: "bold",color:"#000", fontSize: "1rem", textAlign: "right" }}>
                            {n2words(locinf.data.val, { lang: "ar" }) + " ريال"}</div>
                    </Paper>
                </Grid>
                <Grid item xs={4}>
                    <div style={styleR}>{": " + "القيمة بالحروف"}</div>
                </Grid>

                <Grid item xs={8}>
                    {/* <Paper className={clasm.minclr}> */}
                        <div style={{ fontWeight: "bold",color:"#000", fontSize: "0.75rem", textAlign: "right" }}>{locinf.data.notes}</div>
                        {/* </Paper> */}
                </Grid>
                <Grid item xs={4}>
                    <div style={{ fontWeight: "bold",color:"#000", fontSize: "1rem", textAlign: "right" }}>{": " + "البيان"}</div>
                </Grid>
            </Grid>
            <Grid item container style={{ marginTop: 10 }}></Grid>
            {totalsContntE_()}
        </Grid>
    );
};
export default BodySand;
